import React from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT_STATUSES } from "@/components/Admin/statuses";

const formatDate = (iso) =>
  new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });

const formatPhone = (p) => p.replace(/^(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3");

const COLUMNS = ["Data", "Nome / Clínica", "Profissionais", "Contato", "Mensagem", "Origem", "Status"];

const ContactCell = ({ c }) => (
  <div className="admin-cell-stack">
    <a href={`mailto:${c.email}`} className="admin-link">{c.email}</a>
    {c.phone ? (
      <div className="admin-whatsapp">
        <span>{formatPhone(c.phone)}</span>
        <a
          href={`https://wa.me/55${c.phone}`}
          target="_blank"
          rel="noopener noreferrer"
          className="admin-whatsapp-btn"
          data-testid={`admin-whatsapp-${c.id}`}
        >
          <MessageCircle size={14} />
          Abrir WhatsApp
        </a>
      </div>
    ) : (
      <span className="admin-cell-sub">Sem WhatsApp</span>
    )}
  </div>
);

const StatusSelect = ({ c, onChange, saving }) => (
  <select
    className="admin-status-select"
    data-status={c.status}
    value={c.status}
    disabled={saving}
    onChange={(e) => onChange(c.id, e.target.value)}
    aria-label={`Status de ${c.name}`}
    data-testid={`admin-status-select-${c.id}`}
  >
    {CONTACT_STATUSES.map((s) => (
      <option key={s.value} value={s.value}>
        {s.label}
      </option>
    ))}
  </select>
);

const ContactRow = ({ c, onStatusChange, savingId }) => (
  <tr data-testid={`admin-contact-row-${c.id}`}>
    <td data-label="Data" className="admin-cell-nowrap">{formatDate(c.created_at)}</td>
    <td data-label="Nome / Clínica">
      <div className="admin-cell-stack">
        <span className="admin-cell-strong">{c.name}</span>
        <span className="admin-cell-sub">{c.clinic}</span>
      </div>
    </td>
    <td data-label="Profissionais">{c.professionals}</td>
    <td data-label="Contato" className="admin-cell-nowrap"><ContactCell c={c} /></td>
    <td data-label="Mensagem" className="admin-cell-msg">{c.message || "—"}</td>
    <td data-label="Origem" className="admin-cell-nowrap">{c.source}</td>
    <td data-label="Status">
      <div className="admin-cell-stack">
        <StatusSelect c={c} onChange={onStatusChange} saving={savingId === c.id} />
        <span className="admin-cell-sub admin-cell-nowrap" data-testid={`admin-status-updated-${c.id}`}>
          Alterado em {formatDate(c.status_updated_at)}
        </span>
      </div>
    </td>
  </tr>
);

export const ContactsTable = ({ contacts, onStatusChange, savingId }) => {
  if (!contacts.length) {
    return <div className="admin-empty" data-testid="admin-contacts-empty">Nenhum contato neste filtro.</div>;
  }
  return (
    <div className="admin-table-wrap">
      <table className="admin-table" data-testid="admin-contacts-table">
        <thead>
          <tr>
            {COLUMNS.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {contacts.map((c) => (
            <ContactRow key={c.id} c={c} onStatusChange={onStatusChange} savingId={savingId} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
